import { render, staticRenderFns } from "./BuildingReport.vue?vue&type=template&id=2e0fba9e"
import script from "./BuildingReport.vue?vue&type=script&lang=js"
export * from "./BuildingReport.vue?vue&type=script&lang=js"
import style0 from "./BuildingReport.vue?vue&type=style&index=0&id=2e0fba9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports